<script setup>
import ManMemDetail from '@/components/admin/member/ManMemDetail.vue'

</script>
<template>
  <ManMemDetail standalone :mid="$route.params.mid"/>
</template>
